













































import { Component, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunitySourceDto from '@/models/Opportunities/OpportunitySourceDto';
import UpdateOpportunitySourceRequest from '@/models/Opportunities/UpdateOpportunitySourceRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'OpportunitySourceEdit'
})
export default class extends GiganautVueDialog {

  public entity = new OpportunitySourceDto

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(AgencySettingsModule.currentOpportunitySource));
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get isSystem(): boolean {
    const src = AgencySettingsModule.currentOpportunitySource;
    return !!src && src.isSystem;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateOpportunitySourceRequest()
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    await AgencySettingsModule.editOpportunitySource(request)
    this.dialog = false;
  }
}
